const FEATURE_FLAG_NAMES = {
    OPTIONAL_TIPS_COPY_TREATMENT: 'driver-tips-optional-copy',
    UP_SELLS_CAROUSEL_PLP: 'upsells-carousel-plp',
    UP_SELLS_CAROUSEL_PDP: 'upsells-carousel-pdp',
    PLUS_MEMBERSHIP: 'membership',
    MOBILE_PAYMENT_CTA: 'mobile-payment-cta',
    SNAP_EBT: 'snap-ebt',
    PROGRAMMATIC_SEEDING: 'programmatic-seeding',
    CAROUSEL_PRODUCT_PERSONALIZATION: 'carousel-product-personalization',
    M_PLUS_IN_YOUR_FACE: 'm-plus-in-your-face',
    FUNNEL_REGISTRATION_TEST_V2: 'funnel-registration-test-v2',
};

export { FEATURE_FLAG_NAMES };
